import React from "react";
import { Box } from "@chakra-ui/react";
import { FormattedMessage, FormattedNumber, useIntl } from "react-intl";
import en from "translations/translation-website.en.json";

const DEFAULT_VALUES = {
  b: (chunks) => <b key="b">{chunks}</b>,
  i: (chunks) => <i key="i">{chunks}</i>,
  sup: (chunks) => <sup key="sup">{chunks}</sup>,
  br: <br key="br" />,
  highlight: (chunks) => (
    <Box as="span" key="highlight" color="primary" fontWeight="bold">
      {chunks}
    </Box>
  ),
};

const isTranslationKey = (id) => {
  if (!id || typeof id !== "string") return false;
  // If it exists in our English dictionary, it's definitively a key
  if (en[id] !== undefined) return true;
  // Fallback: check if it matches the standard uppercase key format (e.g. LBL_XYZ)
  return /^[A-Z0-9_]+$/.test(id);
};

const Trans = React.memo(({ id, values, ...props }) => {
  if (!isTranslationKey(id)) {
    return <>{id}</>;
  }

  return (
    <FormattedMessage
      defaultMessage={en[id]}
      id={id}
      values={{ ...DEFAULT_VALUES, ...values }}
      {...props}
    />
  );
});

Trans.displayName = "Trans";

export const Currency = (props) => (
  <FormattedNumber style="currency" currency="GBP" {...props} />
);

export const Number = (props) => <FormattedNumber {...props} />;

export const useTrans = useIntl;

export const useFormatMessage = () => {
  const { formatMessage } = useIntl();
  return ({ id, values }) => {
    if (!isTranslationKey(id)) {
      return id;
    }
    return formatMessage({ id, defaultMessage: en[id] }, values);
  };
};

export default Trans;
